
import { getMinValue } from "../PurchaseOrdersComponent";
import FormulaLayout from "./FormulaLayout";

const FinalNetWeight = ({ dispatch, net_weight, miller_bill_weight, unit }) => {
  const finalVal = getMinValue(
    dispatch,
    net_weight,
    miller_bill_weight
  ).toFixed(3);
  return (
    <FormulaLayout>
      <strong>Final Net Weight Formula:</strong>
      <br />
      <br />
      = min(Dispatch Weight,Net Weight, Miller Bill Weight)
      <br /> = min({Number(dispatch).toFixed(3)},{net_weight},{Number(miller_bill_weight).toFixed(3)}) {unit}
      <br />
      <strong> </strong> = {finalVal} {unit}
    </FormulaLayout>
  );
};

export default FinalNetWeight;
